/* Currency formatter helper */
window.default_money_format = "${{amount}}";
window.formatMoney = function(cents, format) {
  if (typeof cents === 'string'){ 
    cents = cents.replace('.', '');
  }

  let value = '';

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = (format || window.default_money_format);

  function defaultOption(opt, def) {
    return (typeof opt === 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/* Web component */
class CustomSizes extends HTMLElement {
  constructor() {
    super();

    /* Elements */
    this.widthInput = this.querySelector('input[name^="width"]');
    this.heightInput = this.querySelector('input[name^="height"]');
    this.quantityInput = this.querySelector('input[name="quantity"]');
    this.form = this.parentNode.querySelector('form[id^="main-product-form"]');
    this.decreaseButtons = this.querySelectorAll('[data-action="decrease"]');
    this.increaseButtons = this.querySelectorAll('[data-action="increase"]');
    this.priceContainer = this.parentNode.querySelector('.current-price') || null;
    this.compareAtPriceContainer = this.parentNode.querySelector('.old-price') || null;
    this.vendorShippingPrice = this.getAttribute('data-vendor-shipping') !== null ? Number(this.getAttribute('data-vendor-shipping')) : 0;
    this.vendorCompareAtPrice = this.getAttribute('data-vendor-compare') !== null ? Number(this.getAttribute('data-vendor-compare')) : 0;
    this.pricePerMeterContainer = this.parentNode.querySelector('.price-per-meter .target') || null;
    this.discountText = this.parentNode.querySelector('.discount-text') || null;
    
    /* Properties */
    this.isSquare = typeof this.heightInput === 'undefined' || this.heightInput === null;
    this.step = this.getAttribute('data-step');
    this.priceInCm2 = this.getAttribute('data-price-in-cm2');
    this.compareAtPriceInCm2 = this.getAttribute('data-compare-at-price-in-cm2');
    this.minimalWidth = this.getAttribute('data-minimal-width');
    this.minimalHeight = this.isSquare ? this.minimalWidth : this.getAttribute('data-minimal-height');

    /* Init validation */
    if (!this.checkInit()) {
      return;
    }

    /* Initial price update display */
    this.updatePrice();

    /* Event listeners */
    this.widthInput.addEventListener('change', this.updatePrice.bind(this));
    
    if (!this.isSquare) {
      this.heightInput.addEventListener('change', this.updatePrice.bind(this));
    }

    for (const decreaseButton of this.decreaseButtons) {
      decreaseButton.addEventListener('click', this.decreaseSize.bind(this));
    }

    for (const increaseButton of this.increaseButtons) {
      increaseButton.addEventListener('click', this.increaseSize.bind(this));
    }

    this.form.addEventListener('submit', this.validateForm.bind(this));
  }

  checkInit() {
    if (!this.form) {
      console.error('No form found');
      return false;
    }

    if (!this.quantityInput) {
      console.error('No quantity input found');
      return false;
    }

    if (!this.widthInput) {
      console.error('No width input found');
      return false;
    }

    if (this.minimalWidth === null) {
      console.error('No minimal width set for custom sizes');
      return false;
    }

    if (this.minimalHeight === null) {
      console.error('No minimal height set for custom sizes');
      return false;
    }

    return true;
  }

  decreaseSize(event) {
    const eventFor = event.target.getAttribute('data-for');

    if (eventFor === 'width') {
      const newValue = Number(this.widthInput.value) - Number(this.step);

      if (newValue >= this.minimalWidth) {
        this.widthInput.value = newValue;
      } else {
        this.widthInput.value = this.minimalWidth;
      }
    } else {
      const newValue = Number(this.heightInput.value) - Number(this.step);

      if (newValue >= this.minimalHeight) {
        this.heightInput.value = newValue;
      } else {
        this.heightInput.value = this.minimalHeight;
      }
    }

    this.updatePrice();
  }

  increaseSize(event) {
    const eventFor = event.target.getAttribute('data-for');

    if (eventFor === 'width') {
      const newValue = Number(this.widthInput.value) + Number(this.step);

      if (newValue >= this.minimalWidth) {
        this.widthInput.value = newValue;
      } else {
        this.widthInput.value = this.minimalWidth;
      }
    } else {
      const newValue = Number(this.heightInput.value) + Number(this.step);

      if (newValue >= this.minimalHeight) {
        this.heightInput.value = newValue;
      } else {
        this.heightInput.value = this.minimalHeight;
      }
    }

    this.updatePrice();
  }

  roundWidthAndHeight() {
    const width = Number(this.widthInput.value);
    this.widthInput.value = Math.round(width / 10) * 10;

    if (!this.isSquare) {
      const height = Number(this.heightInput.value);
      this.heightInput.value = Math.round(height / 10) * 10;
    }
  }

  updatePrice() {
    this.roundWidthAndHeight();

    const price = Number(this.priceInCm2);
    const compareAtPrice = this.compareAtPriceInCm2 ? Number(this.compareAtPriceInCm2) : null;
    const width = Number(this.widthInput.value);
    const height = this.isSquare ? width : Number(this.heightInput.value);

    if (width < this.minimalWidth) {
      this.widthInput.value = this.minimalWidth;
    }

    if (!this.isSquare && height < this.minimalHeight) {
      this.heightInput.value = this.minimalHeight;
    }

    /* Quick adjustment for now... */
    /* They are selling fabric and not rugs, and for that reason we are not calculating area, but length. */
    /* Using isSquare is semantically incorrect, however, we know that we only have one input if isSquare is true, */
    /* Which means we are in length mode and not in area mode. */
    /* This is just temporary, and should be addressed if necessary later down the line. */
    const size = this.isSquare ? width : ((width * height) / 100);
    const totalPrice = size * price;
    const totalCompareAtPrice = compareAtPrice ? size * compareAtPrice : null;
    let discountMultiplier = 1;

    if (this.vendorShippingPrice === 0) {
      if (size >= 300 && size < 500) {
        discountMultiplier = 0.93;
      } else if (size >= 500) {
        discountMultiplier = 0.9;
      }
    }

    if (this.priceContainer) {
      this.priceContainer.innerText = window.formatMoney(((totalPrice * 100 * discountMultiplier) + (this.vendorShippingPrice * 100)), window.general.money_format);
    }

    if (this.compareAtPriceContainer) {
      this.compareAtPriceContainer.innerText = window.formatMoney(((totalCompareAtPrice * 100 * discountMultiplier) + (this.vendorCompareAtPrice * 100)), window.general.money_format);
    }

    if (this.pricePerMeterContainer && this.vendorCompareAtPrice > 0) {
      this.pricePerMeterContainer.innerText = window.formatMoney(((((totalCompareAtPrice * 100) + (this.vendorCompareAtPrice * 100)) / size) * 100), window.general.money_format);
    } else if (this.pricePerMeterContainer && this.vendorCompareAtPrice === 0) {
      this.pricePerMeterContainer.innerText = window.formatMoney(((totalPrice * 100 * discountMultiplier) / size) * 100, window.general.money_format);
    }

    if (this.discountText && discountMultiplier < 1) {
      this.discountText.classList.remove('hidden');
      this.discountText.innerText = `${ Math.round((1 - discountMultiplier) * 100) }% Volume korting`;
    } else {
      this.discountText.classList.add('hidden');
    }
  }

  validateForm(event) {
    event.preventDefault() | event.stopImmediatePropagation();

    const productTitle = document.querySelector('#main-product h1').innerText;
    const vendor = document.querySelector('.l4dr.m15 > li > span.strong + a') !== null ? document.querySelector('.l4dr.m15 > li > span.strong + a').innerText : '';
    const productImage = document.querySelector('#main-product .img-multiply img[loading="eager"]').getAttribute('src');
    const width = Number(this.widthInput.value);
    const height = this.isSquare ? width : Number(this.heightInput.value);
    const size = this.isSquare ? width : ((width * height) / 100); /* Same as above */
    let discountMultiplier = 1;

    if (Number(this.vendorShippingPrice) === 0) {
      if (size >= 300 && size < 500) {
        discountMultiplier = 0.93;
      } else if (size >= 500) {
        discountMultiplier = 0.9;
      }
    }

    const totalPrice = (size * Number(this.priceInCm2) * discountMultiplier) + Number(this.vendorShippingPrice);

    const formData = {
      'product_title': `${ productTitle } ${ width }cm${ (this.isSquare ? '' : ` x ${ height }cm`) } (maatwerk)`, /* Same as above */
      'vendor': vendor,
      'price': totalPrice.toFixed(2),
      'product_img': (productImage.startsWith('http:') || productImage.startsWith('https:')) ? productImage :`https:${ productImage }`,
      'weight': '0'
    }

    this.createProduct(formData);
  }

  createProduct(data) {
    fetch('/apps/dominikq/cart/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(function(response) {
      return response.json();
    }).then(function(data) {
      const variantId = data.id;

      setTimeout(function() {
        window.addCartItemById(variantId);
      }.bind(this), 250);
    });
  }
}

customElements.define('custom-sizes', CustomSizes);